import { render } from "./emploiLegumes.vue?vue&type=template&id=79236fea"
import script from "./emploiLegumes.vue?vue&type=script&lang=js"
export * from "./emploiLegumes.vue?vue&type=script&lang=js"

import "./emploiLegumes.vue?vue&type=style&index=0&id=79236fea&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__